<div [@showHidden]="showLoader ? 'show' : 'hidden'" class="container-loader">
    <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>